<template>
    <div>
        <div class="container">
            <div
                class="modal center-modal fade"
                id="succefullPayment"
                tabindex="-1"
                aria-labelledby="succefullPayment"
                aria-hidden="true"
                
                >
                <div
                    class="modal-dialog modal-dialog-center"
                    style="margin-bottom: 50px;"
                >
                    <div class="modal-content">
                        <div
                            class="modal-header pt-4 pb-2"
                            style="margin: 0 14px; padding: inherit;"
                            >
                            <h5 class="modal-title title-modal" id="rc">
                            Payment Successful
                            </h5>
                            <button
                            @click="closeTransaction()"
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            >
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- <hr /> -->
                        <!-- id="receipt-content" -->
                        <div class="modal-body" ref="receipt">
                            <h2 class="success-text">Transaction Summary</h2>
                            <div class="confirmation-holder receipt" v-if="successData && successData.data">
                                <div class="discount-section">
                                    <div>
                                        <h6>Amount</h6>
                                        <h5>₦{{Number(successData.data.totalAmountPaid).toLocaleString()}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'cable' || successData.data.transaction_type == 'Electricity'">
                                        <h6>Transaction Fee</h6>
                                        <h5>₦{{Number(successData.data.statutory_charge).toLocaleString() || 0}}</h5>
                                    </div>
                                    <div v-if="successData.data.reward">
                                        <h6>Reward</h6>
                                        <h5>+{{ successData.data.reward.reward_to_get }}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'Airtime' || successData.data.transaction_type == 'Data' && successData.data.phoneNo != null">
                                        <h6>Phone number</h6>
                                        <h5>{{successData.data.purchasePhone}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'cable' || successData.data.transaction_type == 'Electricity'">
                                        <h6>Name</h6>
                                        <h5>{{successData.data.customerName}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'cable' || successData.data.transaction_type == 'Electricity'">
                                        <h6>Address</h6>
                                        <h5>{{successData.data.address}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'cable'">
                                        <h6>Decoder number</h6>
                                        <h5>{{successData.data.decoder_no}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'cable' || 'Electricity'">
                                        <h6>Type</h6>
                                        <h5>{{successData.data.disco}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'Electricity'">
                                        <h6>Meter number</h6>
                                        <h5>{{successData.data.meter_number}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'Electricity'">
                                        <h6>Units</h6>
                                        <h5>{{successData.data.units}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'Electricity'">
                                        <h6>Disco</h6>
                                        <h5>{{successData.data.disco}} Electricity</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'Electricity'">
                                        <h6>Type</h6>
                                        <h5>{{successData.data.vend_type}}</h5>
                                    </div>
                                    <div v-if="successData.data.transaction_type == 'Electricity'">
                                        <h6>Token</h6>
                                        <h5>
                                            {{successData.data.token}} 
                                            <span><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.25 8.75C5.25 7.1001 5.25 6.27515 5.76256 5.76256C6.27515 5.25 7.1001 5.25 8.75 5.25H9.33333C10.9832 5.25 11.8082 5.25 12.3208 5.76256C12.8333 6.27515 12.8333 7.1001 12.8333 8.75V9.33333C12.8333 10.9832 12.8333 11.8082 12.3208 12.3208C11.8082 12.8333 10.9832 12.8333 9.33333 12.8333H8.75C7.1001 12.8333 6.27515 12.8333 5.76256 12.3208C5.25 11.8082 5.25 10.9832 5.25 9.33333V8.75Z" stroke="#555555" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M9.91669 5.24935C9.91529 3.52438 9.88921 2.63089 9.38708 2.0191C9.29013 1.90095 9.18181 1.79262 9.06368 1.69566C8.41828 1.16602 7.45946 1.16602 5.54175 1.16602C3.62405 1.16602 2.6652 1.16602 2.01983 1.69566C1.90168 1.79261 1.79335 1.90095 1.69639 2.0191C1.16675 2.66447 1.16675 3.62332 1.16675 5.54102C1.16675 7.45872 1.16675 8.41755 1.69639 9.06295C1.79335 9.18107 1.90168 9.2894 2.01983 9.38635C2.63162 9.88848 3.52511 9.91456 5.25008 9.91596" stroke="#555555" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            </span>
                                        </h5>
                                    </div>
                                
                                    <div>
                                        <h6>Transaction Type</h6>
                                        <h5>{{successData.data.transaction_type}}</h5>
                                    </div>
                                    <div>
                                        <h6>Payment Type</h6>
                                        <h5 style="text-transform: capitalize;">{{successData.data.payment_type}}</h5>
                                    </div>
                                    <div>
                                        <h6>Reference No.</h6>
                                        <h5>{{successData.data.vendRef}}</h5>
                                    </div>
                                    <div>
                                        <h6>Status</h6>
                                        <h5>Successful</h5>
                                    </div>
                                    <div>
                                        <h6>Date</h6>
                                        <h5>{{successData.data.vendTime | moment}}</h5>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="extend-duration-btn">
                            <button
                            @click="closeTransaction()"
                            class="btn cancel2"
                            data-dismiss="modal"
                            aria-label="Close"
                            >
                            Close
                            </button>
                            <button
                            disabled
                            class="btn continue3"
                            @click="downloadReceipt()"
                            >
                            Download Receipt
                            <i
                                class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                                v-if="loading"
                            ></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import moment from "moment";
const Api = new Service();
import $ from "jquery";
    export default {
        name: "SuccessfulPayment",
        // props: {
        //     billdata: Object,
        // },
        data() {
            return {
                loading: false,
                successData: {}
            }
        },
        created() {
            this.$root.$refs.openSuccess = this;
        },
        mounted() {
            // console.log("Bills Onbject", this.billdata)
            // this.openSuccessModal()
        },
        methods: {
            closeTransaction() {
                window.location.reload();
            },
            setDataSuccess(data) {
                // console.log("success data:", data);
                this.successData = { ...data };
            },
            openSuccessModal() {
                $("#succefullPayment")
                .addClass("fade")
                .modal("show");
                console.log("Bills Onbject", this.successData)
            },
            downloadReceipt() {
                // console.log("Check dom", document.querySelector('.modal-body').innerHTML)
                // const element = document.getElementById("receipt-content");
                // const element = this.$refs.receipt;

                // const options = {
                //     margin: 10,
                //     filename: `receipt-${this.successData.data.vendRef}.pdf`,
                //     image: { type: "jpeg", quality: 0.98 },
                //     html2canvas: {
                //         scale: 2,
                //         useCORS: true,
                //         backgroundColor: "#ffffff"
                //     },
                //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
                // };

                // html2pdf().set(options).from(element).save();


                // const html2pdf = require("html2pdf.js");
                // const element = document.getElementById("receipt-content");
                // const element = this.$refs.receipt;

                // this.$nextTick(() => {
                //     const el = this.$refs.receipt;

                //     window.html2pdf()
                //     .set({
                //         margin: 0.5,
                //         filename: `receipt-${this.receipt.reference}.pdf`,
                //         html2canvas: {
                //         scale: 2,
                //         useCORS: true,
                //         backgroundColor: "#ffffff"
                //         },
                //         jsPDF: { unit: "in", format: "A4" }
                //     })
                //     .from(el)
                //     .save();
                // });
            },
        },
        filters: {
            moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
            },
            moment2: function(date) {
            return moment(date).format("MMMM Do YYYY");
            }
        }
    }
        
</script>

<style scoped lang="scss">
.confirmation-holder {
  background: #F8F9FA;
  border-radius: 8px;
  padding: 10px;
  h5, h6 {
    font-family: Lato;
    font-size: 14px;
    line-height: 40px;
    color: #555555;
  }
  h6 {
    font-weight: 400;
  }
  h5 {
    font-weight: 500;
    // span {
    //   background: #FFB100;
    //   padding: 4px 8px;
    //   border-radius: 50px;
    //   font-size: 10px;
    //   color: #ffffff;
    //   margin-left: 5px;
    //   font-family: Lato;
    //   cursor: pointer;
    // }
  }
}
.discount-section:not(:last-child) {
  border-bottom: 1px dashed #E6E9EC;
}
.discount-section  > div {
  display: flex;
  justify-content: space-between;
}

.success-text {
    font-family: Lato;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    color: #1a1a1a;
}

.extend-duration-btn {
  padding: 10px 14px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 30px;

  .cancel2 {
    border-radius: 8px;
    height: 44px;
    // border: 1px solid #d0d5dd;
    color: #0022AA;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    height: 48px;
    width: 100%;
    box-shadow: none;
    outline: 0;
    background: #E6F0FA;
  }

  .continue3 {
    border-radius: 8px;
    height: 44px;
    background: #0033EA;
    color: #ffffff;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    height: 48px;
    width: 100%;
    box-shadow: none;
    outline: 0;
    white-space: nowrap;
  }
}

.receipt {
  position: relative;
  background-image: url('../../assets/logo.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 300px;
  background-blend-mode: overlay; 
  background-color: rgba(255, 255, 255, 0.9); 
}

@media only screen and (max-width: 599px) {
  .confirmation-holder {
    h5, h6 {
      font-size: 12px;
    }
  }
}
</style>